export default __webpack_public_path__ + "static/media/headerimg.bca7a823.png";